import useQuickAction from "../../hooks/useQuickAction";
import { useEffect, useState } from "react";
import spinner from "../../assets/images/spinner.gif";
import { Modal } from "@mui/material";
import { PencilAltIcon, TrashIcon, XIcon } from "@heroicons/react/solid";
import Radio from "../../components/radio/Radio";
import {
  deleteHolidayForm,
  postHolidayForm,
  updateHolidayForm,
} from "../../api/holiday";
import Moment from "react-moment";
import useRead from "../../hooks/useRead";
import { useSearchParams, useNavigate } from "react-router-dom";
import Pagination from "../../components/pagination";
import { useQueryClient } from "@tanstack/react-query";
import useGet from "../../hooks/read/useGet";
import DatePicker from "react-datepicker";
import Cookies from "universal-cookie";
import { ROLE } from "../../config";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../components/table/Table";
import RoundedContainer from "../../components/containers/RoundedContainer";
import { Button } from "../../components/ui";

const cookies = new Cookies();

let IS_REQUIRED = true;
function Holidays() {
  const navigate = useNavigate();
  const [role, setRole] = useState("");
  useEffect(() => {
    setRole(cookies.get(ROLE));
  }, []);
  const queryClient = useQueryClient();
  const [searchParams, setSearchParams] = useSearchParams();
  const initialState = {
    holiday_type: "single",
    from_date: "",
    to_date: "",
    title: "",
    employment_type: [],
  };
  /**
   * Work around for the date is converted to year only
   * two states are used for this one foe saving the date object and one for only year will be sent to backend
   */
  let initialHolidayData = {
    limit: 50,
    search_query: searchParams.get("search_query") || "",
    page_number: searchParams.get("page_number") || 0,
    year: searchParams.get("year")
      ? new Date(searchParams.get("year")).getFullYear()
      : new Date().getFullYear(),
  };
  let initialHolidayFilterData = {
    limit: 50,
    search_query: searchParams.get("search_query") || "",
    page_number: searchParams.get("page_number") || 0,
    year: searchParams.get("year")
      ? new Date(searchParams.get("year"))
      : new Date(),
  };
  const [holidayId, setHolidayId] = useState("");
  const [filterData, setFilterData] = useState(initialHolidayFilterData);

  const [holidayData, setHolidayData] = useState(initialState);
  const [holidayModal, setHolidayModal] = useState(false);
  useQuickAction("add-holiday", () => setHolidayModal(true));
  const [isAddingData, setAddingData] = useState(false);
  const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [openHolidayEditModal, setOpenHolidayEditModal] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const {
    list: holidayList,
    paramsObject,
    setGetListParams,
  } = useGet({
    url: "holidaylist",
    method: "get",
    initialData: initialHolidayData,
  });

  const handleHolidayFormInputs = (e) => {
    let value = e.target.value;
    let data = {
      ...holidayData,
      [e.target.name]: value,
    };
    setHolidayData(data);
  };

  const { list: employmentList } = useRead({
    url: "employment_listing",
    initialData: {
      limit: 50,
      search_query: "",
    },
    enabled: role === "COMPANY_ADMIN",
  });

  const handleSubmitFormData = (e) => {
    setAddingData(true);
    e.preventDefault();
    postHolidayForm(holidayData)
      .then((res) => {
        if (res.status === 200) {
          // handleFetchHoliday()
          queryClient.invalidateQueries("holidaylist");
          queryClient.invalidateQueries(["dashboard/company_completion_status"]);
          queryClient.invalidateQueries(["is_permission_for_product"]);
          setAddingData(false);
          setHolidayModal(false);
          setHolidayData(initialState);
          if (sessionStorage.getItem("onboarding_flow") === "true") {
            sessionStorage.removeItem("onboarding_flow");
            // navigate("/onboarding");
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleCancelForm = () => {
    setHolidayModal(false);
    setHolidayData(initialState);
    setOpenHolidayEditModal(false);
  };

  const handleOpenDeleteModal = (id) => {
    setHolidayId(id);
    setDeleteConfirmationModal(true);
  };
  const handleDeleteLeave = () => {
    setIsDeleting(true);
    deleteHolidayForm(holidayId)
      .then((res) => {
        if (res.status === 200) {
          setDeleteConfirmationModal(false);
          // handleFetchHoliday()
          queryClient.invalidateQueries("holidaylist");
          queryClient.invalidateQueries(["dashboard/company_completion_status"]);
          queryClient.invalidateQueries(["is_permission_for_product"]);
          setIsDeleting(false);
        }
      })
      .catch((err) => {
        alert("Something went wrong!");
        setIsDeleting(false);
      });
  };

  const handleGetSingleLeaveData = (id) => {
    setHolidayData(holidayList.data.data?.find((data) => data.id === id));
    setOpenHolidayEditModal(true);
  };

  const handleEditHoliday = (e) => {
    setIsUpdating(true);
    e.preventDefault();
    updateHolidayForm(holidayData)
      .then((res) => {
        if (res.status === 200) {
          // handleFetchHoliday()
          queryClient.invalidateQueries("holidaylist");
          queryClient.invalidateQueries(["dashboard/company_completion_status"]);
          queryClient.invalidateQueries(["is_permission_for_product"]);
          setOpenHolidayEditModal(false);
          setHolidayData(initialState);
          setIsUpdating(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsUpdating(false);
      });
  };

  const handleCheckValue = (e, item) => {
    let checked = e.target.checked;
    if (checked) {
      setHolidayData((prev) => {
        return {
          ...prev,
          employment_type: [...holidayData.employment_type, item.id],
        };
      });
    } else {
      let checkedId = holidayData.employment_type.filter((x) => x !== item.id);
      setHolidayData((prev) => {
        return {
          ...prev,
          employment_type: checkedId,
        };
      });
    }
  };

  const handlePageClick = (val) => {
    let data = {
      ...paramsObject,
      page_number: val.selected,
    };
    setGetListParams(data);
    setSearchParams(data);
  };

  /**
   * Work around for the date is converted to year only
   * two states are used for this one foe saving the date object and one for only year will be sent to backend
   */
  const handleSetYear = (value) => {
    let data = {
      ...paramsObject,
      year: new Date(value).getFullYear(),
    };
    let dataForSearchParams = {
      ...paramsObject,
      year: value,
    };
    setGetListParams(data);
    setSearchParams(dataForSearchParams);
    setFilterData(dataForSearchParams);
  };

  return (
    <div className="pt-5">
      <div className="flex items-end justify-between px-4">
        <div className=" lg:basis-[25%]">
          <label className=" roboto p-2 label">Select Year</label>
          {filterData.year && (
            <DatePicker
              name="month_and_year"
              autoComplete="false"
              className="input"
              selected={filterData.year}
              showYearPicker
              dateFormat="yyyy"
              onChange={handleSetYear}
            />
          )}
        </div>
        {role === "EMPLOYEE" || role === "consultant" ? null : (
          <div className="text-end">
            <Button onClick={() => setHolidayModal(true)} variant={"default"}>
              Add holiday
            </Button>
          </div>
        )}
      </div>
      {holidayList.isLoading ? (
        <div className=" w-16 h-16 mx-auto mt-8">
          <img src={spinner} alt="spinner" className="w-full h-full" />
        </div>
      ) : (
        <div className="max-w-full px-4 mt-8">
          {!holidayList.data?.data?.length ? (
            <RoundedContainer className="text-center py-16">
              <p className="text-gray-700 text-2xl font-semibold mb-2">No Holidays To Show</p>
              <p className="text-gray-500 text-sm mb-5">Add upcoming holidays for the selected calendar year.</p>
              {role !== "EMPLOYEE" && role !== "consultant" && (
                <Button onClick={() => setHolidayModal(true)} variant={"default"}>
                  Add Holiday
                </Button>
              )}
            </RoundedContainer>
          ) : (
            <>
              <RoundedContainer>
                <Table className="table-auto w-full">
                  <TableHead>
                    <TableHeaderCell className="w-[10%] text-center hidden lg:table-cell">
                      Sr.No
                    </TableHeaderCell>
                    <TableHeaderCell className="w-[45%]">
                      Holiday Name
                    </TableHeaderCell>
                    <TableHeaderCell className="w-[30%] text-center">
                      From - To Date
                    </TableHeaderCell>
                    {role === "EMPLOYEE" || role === "consultant" ? null : (
                      <>
                        {/* <TableHeaderCell className="w-[20%] text-center">
                          Applicable To
                        </TableHeaderCell> */}
                        <TableHeaderCell className="w-[15%] text-center">
                          Action
                        </TableHeaderCell>
                      </>
                    )}
                  </TableHead>
                  <TableBody>
                    {holidayList.data?.data?.map((data, idx) => {
                      const {
                        id,
                        title,
                        from_date,
                        to_date,
                        holiday_type,
                        applicable,
                      } = data;
                      return (
                        <TableRow key={idx}>
                          <TableCell className="text-center text-dark font-medium text-sm hidden lg:table-cell">
                            {idx + 1}
                          </TableCell>
                          <TableCell className="text-dark font-medium text-sm">
                            {title}
                          </TableCell>
                          <TableCell className="text-center text-dark font-medium text-sm">
                            <Moment format="ll">{from_date}</Moment>
                            {holiday_type === "multiple" && (
                              <>
                                {" "}
                                - <Moment format="ll">{to_date}</Moment>
                              </>
                            )}
                          </TableCell>
                          {role === "EMPLOYEE" ||
                          role === "consultant" ? null : (
                            <>
                              {/* <TableCell className="text-center text-dark font-medium text-sm capitalize">
                                {applicable?.toLowerCase()}
                              </TableCell> */}
                              <TableCell className="text-center text-dark font-medium text-sm">
                                <div className="flex justify-center items-center space-x-1">
                                  <Button
                                    variant={"ghost"}
                                    size={"icon"}
                                    onClick={() => handleGetSingleLeaveData(id)}
                                  >
                                    <PencilAltIcon className="text-gray-500 w-5 h-5 hover:text-primary transition-colors" />
                                  </Button>
                                  <Button
                                    variant={"ghost"}
                                    size={"icon"}
                                    onClick={() => handleOpenDeleteModal(id)}
                                  >
                                    <TrashIcon className="text-gray-500 w-5 h-5 hover:text-red-600 transition-colors" />
                                  </Button>
                                </div>
                              </TableCell>
                            </>
                          )}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </RoundedContainer>
              {holidayList.data?.total_count > paramsObject.limit && (
                <RoundedContainer className="mt-4">
                  <Pagination
                    currentPage={+paramsObject.page_number}
                    lengthofItems={holidayList.data?.total_count}
                    limit={paramsObject.limit}
                    onPageChange={handlePageClick}
                  />
                </RoundedContainer>
              )}
            </>
          )}
        </div>
      )}

      {/* Modals */}
      <Modal
        open={holidayModal}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
      >
        <div className="w-[60%] bg-white absolute left-1/2 -translate-x-1/2 top-[1%]">
          <div className="document-wrapper px-4 divide-y">
            <div className="document-head py-4">
              <div className="flex items-center justify-between">
                <h3 className=" text-gray-700 text-3xl font-semibold">
                  Public Holiday
                </h3>
                <div
                  className=" w-6 h-6 cursor-pointer"
                  onClick={handleCancelForm}
                >
                  <XIcon className=" text-black w-full h-full" />
                </div>
              </div>
            </div>
            <div className="document-body max-h-[30rem] overflow-auto">
              <form
                method="post "
                className="divide-y"
                onSubmit={handleSubmitFormData}
              >
                <div className="grid grid-cols-2 gap-4 py-4">
                  <div className="">
                    <p className="label">
                      Holiday Type:<span className="mandatory">*</span>
                    </p>
                    <div className=" flex gap-x-4">
                      <Radio
                        label={"Single"}
                        name={"holiday_type"}
                        value={"single"}
                        val={holidayData.holiday_type}
                        onChange={handleHolidayFormInputs}
                      />
                      <Radio
                        label={"Multiple"}
                        name={"holiday_type"}
                        value={"multiple"}
                        val={holidayData.holiday_type}
                        onChange={handleHolidayFormInputs}
                      />
                    </div>
                  </div>
                  <div className="">
                    <label htmlFor="holiday_name" className="label">
                      Holiday Name:<span className="mandatory">*</span>
                    </label>
                    <input
                      type="text"
                      name="title"
                      required={IS_REQUIRED}
                      className="input"
                      placeholder="Enter Holiday name "
                      value={holidayData.title}
                      onChange={handleHolidayFormInputs}
                    />
                  </div>
                  <div className="">
                    <label htmlFor="from_date" className="label">
                      From Date:<span className="mandatory">*</span>
                    </label>
                    <input
                      type="date"
                      name="from_date"
                      className="input"
                      required={IS_REQUIRED}
                      value={holidayData.from_date}
                      onChange={handleHolidayFormInputs}
                      placeholder="Date of joining"
                    />
                  </div>
                  {holidayData.holiday_type === "multiple" && (
                    <div className="">
                      <label htmlFor="to_date" className="label">
                        To Date
                      </label>
                      <input
                        type="date"
                        name="to_date"
                        className="input"
                        value={holidayData.to_date}
                        onChange={handleHolidayFormInputs}
                        placeholder="Date of leaving"
                      />
                    </div>
                  )}
                  {/* <div className="">
                                        <label htmlFor="employment_type To" className='label'>employment_type To<span className='mandatory'>*</span></label>
                                        <select name="employment_type" className='input' required={IS_REQUIRED} value={holidayData.employment_type} onChange={handleHolidayFormInputs}>
                                            <option value="">-- Select employment_type To --</option>
                                            <option value="BOTH">Both</option>
                                            <option value="EMPLOYEE">Employee</option>
                                        </select>
                                    </div> */}
                </div>
                <div className=" py-4">
                  <label htmlFor="Applicable To" className="label block">
                    Applicable To<span className="mandatory">*</span>
                  </label>
                  {employmentList.data?.data?.map((item) => {
                    const { id, name } = item;
                    return (
                      <label
                        key={id}
                        className="border border-gray-300 rounded-md px-4 py-2 mb-2 mr-2 space-x-2 inline-block cursor-pointer"
                      >
                        <input
                          type="checkbox"
                          checked={holidayData?.employment_type?.includes(id)}
                          onChange={(e) => handleCheckValue(e, item)}
                        />
                        <span className="text-sm">{name}</span>
                      </label>
                    );
                  })}
                </div>
                <div className="document-foot space-x-4 py-4">
                  {isAddingData ? (
                    <div className=" w-8 h-8 mx-auto">
                      <img
                        src={spinner}
                        alt="spinner"
                        className="w-full h-full"
                      />
                    </div>
                  ) : (
                    <div className="text-center space-x-4">
                      <Button className="font-semibold">Save</Button>
                      <Button
                        type="button"
                        variant={"outline"}
                        className="font-semibold"
                        onClick={handleCancelForm}
                      >
                        Cancel
                      </Button>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        open={openHolidayEditModal}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
      >
        <div className="w-[60%] bg-white absolute left-1/2 -translate-x-1/2 top-[1%]">
          <div className="document-wrapper px-4 divide-y">
            <div className="document-head py-4">
              <div className="flex items-center justify-between">
                <h3 className=" text-gray-700 text-3xl font-semibold">
                  Edit Public Holiday
                </h3>
                <div
                  className=" w-6 h-6 cursor-pointer"
                  onClick={handleCancelForm}
                >
                  <XIcon className=" text-black w-full h-full" />
                </div>
              </div>
            </div>
            <div className="document-body max-h-[30rem] overflow-auto">
              <form
                method="post "
                className="divide-y"
                onSubmit={handleEditHoliday}
              >
                <div className="grid grid-cols-2 gap-4 py-4">
                  <div className="">
                    <p className="label">
                      Holiday Type:<span className="mandatory">*</span>
                    </p>
                    <div className=" flex gap-x-4">
                      <Radio
                        label={"Single"}
                        name={"holiday_type"}
                        value={"single"}
                        val={holidayData.holiday_type}
                        onChange={handleHolidayFormInputs}
                      />
                      <Radio
                        label={"Multiple"}
                        name={"holiday_type"}
                        value={"multiple"}
                        val={holidayData.holiday_type}
                        onChange={handleHolidayFormInputs}
                      />
                    </div>
                  </div>
                  <div className="">
                    <label htmlFor="holiday_name" className="label">
                      Holiday Name:<span className="mandatory">*</span>
                    </label>
                    <input
                      type="text"
                      name="title"
                      required={IS_REQUIRED}
                      className="input"
                      placeholder="Enter Holiday name "
                      value={holidayData.title}
                      onChange={handleHolidayFormInputs}
                    />
                  </div>
                  <div className="">
                    <label htmlFor="from_date" className="label">
                      From Date:<span className="mandatory">*</span>
                    </label>
                    <input
                      type="date"
                      name="from_date"
                      className="input"
                      required={IS_REQUIRED}
                      value={holidayData.from_date}
                      onChange={handleHolidayFormInputs}
                      placeholder="Date of joining"
                    />
                  </div>
                  {holidayData.holiday_type === "multiple" && (
                    <div className="">
                      <label htmlFor="to_date" className="label">
                        To Date
                      </label>
                      <input
                        type="date"
                        name="to_date"
                        className="input"
                        value={holidayData.to_date}
                        onChange={handleHolidayFormInputs}
                        placeholder="Date of leaving"
                      />
                    </div>
                  )}
                </div>
                <div className=" py-4">
                  <label htmlFor="Applicable To" className="label block">
                    Applicable To<span className="mandatory">*</span>
                  </label>
                  {employmentList.data?.data?.map((item) => {
                    const { id, name } = item;
                    return (
                      <label
                        key={id}
                        className="border border-gray-300 rounded-md px-4 py-2 mb-2 mr-2 space-x-2 inline-block cursor-pointer"
                      >
                        <input
                          type="checkbox"
                          checked={holidayData?.employment_type?.includes(id)}
                          onChange={(e) => handleCheckValue(e, item)}
                        />
                        <span className="text-sm">{name}</span>
                      </label>
                    );
                  })}
                </div>
                <div className="document-foot space-x-4 py-4">
                  {isUpdating ? (
                    <div className=" w-8 h-8 mx-auto">
                      <img
                        src={spinner}
                        alt="spinner"
                        className="w-full h-full"
                      />
                    </div>
                  ) : (
                    <div className="text-center space-x-4">
                      <Button className="">Update</Button>
                      <Button
                        type="button"
                        variant={"outline"}
                        className="font-semibold"
                        onClick={handleCancelForm}
                      >
                        Cancel
                      </Button>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>
      <Modal open={deleteConfirmationModal}>
        <div className="w-[60%] bg-white absolute left-1/2 -translate-x-1/2 top-[20%]">
          <div className="document-wrapper px-4 divide-y">
            <div className="document-head py-4">
              <div className="flex items-center justify-between">
                <h3 className=" text-gray-700 text-3xl font-semibold">
                  Delete Holiday
                </h3>
                <div
                  className=" w-6 h-6 cursor-pointer"
                  onClick={() => setDeleteConfirmationModal(false)}
                >
                  <XIcon className=" text-black w-full h-full" />
                </div>
              </div>
            </div>
            <div className="document-body max-h-96 overflow-auto py-4">
              <div>
                <p className=" roboto text-center font-bold text-2xl text-gray-700 mb-4">
                  Are you sure you want to delete this Field?
                </p>
                {isDeleting ? (
                  <div className=" w-8 h-8 mx-auto">
                    <img
                      src={spinner}
                      alt="spinner"
                      className="w-full h-full"
                    />
                  </div>
                ) : (
                  <div className="space-x-3 text-center ">
                    <Button
                      className="font-semibold bg-red-200 text-red-700 border-red-800"
                      onClick={handleDeleteLeave}
                    >
                      Yes
                    </Button>
                    <Button
                      className="font-semibold"
                      variant={"outline"}
                      onClick={() => setDeleteConfirmationModal(false)}
                    >
                      Cancel
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Holidays;
